import FooterTransparent from "../../Components/footerTransparente";
import API_URL from "../../const";
import { useEffect, useState, useMemo, useRef } from "react";
import Headers from "../../Components/HeaderPrivate";
import Toast from "../../Components/Toast/Toast";
import ToastError from "../../Components/Toast/ToastError";
import { useNavigate } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Spinner from "../../Components/Spinner/Spinner";
import TabUsuarios from "./components/TabUsuarios";
import TabEmpresas from "./components/TabEmpresas";
import TabContactos from "./components/TabContactos";
import TabBoletines from "./components/TabBoletines";
import TabEventos from "./components/TabEventos";

function AnalyticsPage() {
  {
    /*-------------------- Inicio Componente filtro y buscador y opción de usuarios/empresas --------------------*/
  }
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsuarios, setFilteredUsuarios] = useState([]);
  const [filterType, setFilterType] = useState("activos"); // opciones: "todos", "usuarios", "empresas"
  const [sortField, setSortField] = useState("id_usuario");
  const [sortDirection, setSortDirection] = useState("desc"); // Opciones: "asc" o "desc"
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null); // Para almacenar el usuario seleccionado para eliminar
  const [bajaEmpresaModalOpen, setBajaEmpresaModalOpen] = useState(false);
  const [empresaToDelete, setEmpresaToDelete] = useState(null); // Para almacenar la empresa seleccionada para eliminar
  const [empresasData, setEmpresasData] = useState([]);
  const [searchTermEmpresa, setSearchTermEmpresa] = useState("");
  const [filteredEmpresas, setFilteredEmpresas] = useState([]);
  const [filteredNombreEmpresa, setFilteredNombreEmpresa] = useState("");
  const [filterGiro, setFilterGiro] = useState("");
  const [filterEstado, setFilterEstado] = useState("");
  const [filterDireccion, setFilterDireccion] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [boletinToDelete, setBoletinToDelete] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedBoletin, setSelectedBoletin] = useState(null);
  const [isDeleteEventoModalOpen, setIsDeleteEventoModalOpen] = useState(false);
  const [eventoToDelete, setEventoToDelete] = useState(null);
  const [selectedContacto, setSelectedContacto] = useState(null);
  const [isViewContactModalOpen, setIsViewContactModalOpen] = useState(false);
  const [hasNewContacts, setHasNewContacts] = useState(true);
  const [contactosData, setContactosData] = useState([]);
  const lastSeenRef = useRef(localStorage.getItem("lastContactView"));
  const [recoveryStatus, setRecoveryStatus] = useState({
    email: "",
    status: "",
  });
  const [deletePermanentModalOpen, setDeletePermanentModalOpen] =
    useState(false);
  const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
  const [userToResetPassword, setUserToResetPassword] = useState(null);
  const [showReactivarModal, setShowReactivarModal] = useState(false);
  const [userToReactivate, setUserToReactivate] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("activos");
  const [selectedUserToReactivate, setSelectedUserToReactivate] =
    useState(null);
  const [isReactivationModalOpen, setIsReactivationModalOpen] = useState(false);
  const [contactosSortField, setContactosSortField] = useState("fechaRegistro");
  const [contactosSortDirection, setContactosSortDirection] = useState("desc");
  const [searchTermContacto, setSearchTermContacto] = useState("");

  // Estados para editar empresas
  const [editEmpresaModalOpen, setEditEmpresaModalOpen] = useState(false);
  const [empresaToEdit, setEmpresaToEdit] = useState(null);
  const [editEmpresaForm, setEditEmpresaForm] = useState({
    id_empresa: "",
    nombre: "",
    giro: "",
    direccion: "",
    rfc: "",
    tamanio: "",
    estado: "",
    municipio: "",
    especialidad: "",
    sede: "",
    fundacion: "",
    sitioWeb: "",
    telefono: "",
    email: "",
    colorHex: "#000000",
    mision: "",
    vision: "",
    instagram: "",
    facebook: "",
    linkedin: "",
    googleUrl: "",
    whatsapp: "",
    logo: null,
    portada: null,
  });

  // status puede ser: "success", "error", "" (neutral)

  const nuevosContactos = useMemo(() => {
    return (
      contactosData?.filter((item) => item.visto === "0" || item.visto === 0) ||
      []
    );
  }, [contactosData]);

  const handleViewContacto = (contacto) => {
    setSelectedContacto(contacto);
  };

  const handleCloseViewContactModal = () => {
    setIsViewContactModalOpen(false);
    setSelectedContacto(null);
  };

  // Escapa valores para CSV, evitando saltos de línea que rompen filas
  const csvEscape = (value) => {
    if (value === null || value === undefined) return '""';
    const normalized = String(value).replace(/\r?\n|\r/g, " ");
    return `"${normalized.replace(/"/g, '""')}"`;
  };

  // Función para descargar contactos en CSV
  const handleDownloadContactosCSV = () => {
    if (!contactosData || contactosData.length === 0) {
      setMsg("No hay contactos para descargar");
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
      }, 3000);
      return;
    }

    // Crear encabezados del CSV
    const headers = [
      "ID",
      "Nombre",
      "Teléfono",
      "Email",
      "Empresa/Puesto",
      "Núm. colaboradores",
      "Mensaje",
      "Fecha de Registro",
    ];

    // Crear filas del CSV
    const rows = contactosData.map((item) => [
      item.id,
      item.nombre,
      item.numero,
      item.email,
      item.empresa,
      item.numero_colaboradores ?? "",
      item.mensaje,
      new Date(item.fechaRegistro).toLocaleString("es-MX"),
    ]);

    // Combinar encabezados y filas
    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.map(csvEscape).join(",")),
    ].join("\n");

    // Crear blob y descargar
    const blob = new Blob(["\ufeff" + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `contactos_${new Date().toISOString().split("T")[0]}.csv`,
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setMsg("Contactos descargados exitosamente");
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  // Función para descargar un contacto individual en CSV
  const handleDownloadContactoIndividual = (contacto) => {
    if (!contacto) {
      setMsg("No hay datos del contacto para descargar");
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
      }, 3000);
      return;
    }

    // Crear encabezados del CSV
    const headers = [
      "ID",
      "Nombre",
      "Teléfono",
      "Email",
      "Empresa/Puesto",
      "Núm. colaboradores",
      "Mensaje",
      "Fecha de Registro",
    ];

    // Crear fila del contacto
    const row = [
      contacto.id,
      contacto.nombre,
      contacto.numero,
      contacto.email,
      contacto.empresa,
      contacto.numero_colaboradores ?? "",
      contacto.mensaje,
      new Date(contacto.fechaRegistro).toLocaleString("es-MX"),
    ];

    // Combinar encabezados y fila
    const csvContent = [headers.join(","), row.map(csvEscape).join(",")].join(
      "\n",
    );

    // Crear blob y descargar
    const blob = new Blob(["\ufeff" + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    const nombreArchivo = `contacto_${contacto.nombre.replace(/\s+/g, "_")}_${
      contacto.id
    }.csv`;
    link.setAttribute("download", nombreArchivo);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setMsg(`Contacto de ${contacto.nombre} descargado exitosamente`);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  // Función para ordenar contactos
  const handleSortContactos = (field) => {
    if (contactosSortField === field) {
      setContactosSortDirection(
        contactosSortDirection === "asc" ? "desc" : "asc",
      );
    } else {
      setContactosSortField(field);
      setContactosSortDirection("asc");
    }
  };

  // Filtrar y ordenar contactos
  const filteredContactosData = useMemo(() => {
    if (!Array.isArray(contactosData)) return [];

    let filtered = contactosData.filter((item) => {
      const searchLower = searchTermContacto.toLowerCase();
      return (
        item.nombre?.toLowerCase().includes(searchLower) ||
        item.email?.toLowerCase().includes(searchLower) ||
        item.empresa?.toLowerCase().includes(searchLower) ||
        item.numero?.toLowerCase().includes(searchLower) ||
        item.mensaje?.toLowerCase().includes(searchLower) ||
        String(item.numero_colaboradores ?? "")
          .toLowerCase()
          .includes(searchLower)
      );
    });

    // Ordenar
    filtered.sort((a, b) => {
      let aValue = a[contactosSortField];
      let bValue = b[contactosSortField];

      if (contactosSortField === "fechaRegistro") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (aValue < bValue) return contactosSortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return contactosSortDirection === "asc" ? 1 : -1;
      return 0;
    });

    return filtered;
  }, [
    contactosData,
    searchTermContacto,
    contactosSortField,
    contactosSortDirection,
  ]);

  const fetchContactosYResaltar = async () => {
    try {
      const res = await fetch(`${API_URL}getContactanos.php`);
      const data = await res.json();

      if (Array.isArray(data)) {
        const lastSeen = localStorage.getItem("lastContactView");

        const contactosConResaltado = data.map((item) => {
          const esNuevo =
            item.visto === "0" ||
            item.visto === 0 ||
            (lastSeen && new Date(item.fechaRegistro) > new Date(lastSeen));

          return {
            ...item,
            resaltado: esNuevo,
          };
        });

        setContactosData(contactosConResaltado);

        const nuevos = contactosConResaltado.filter((item) => item.resaltado);

        if (nuevos.length > 0) {
          const fechaMasReciente = nuevos[0].fechaRegistro;
          localStorage.setItem("lastContactView", fechaMasReciente);
          lastSeenRef.current = fechaMasReciente;
          setHasNewContacts(true);

          // ahora sí: después de 5 segundos que el usuario ya vio el resaltado
          setTimeout(() => {
            setContactosData((prev) =>
              prev.map((item) => ({ ...item, resaltado: false })),
            );
          }, 5000);
        } else {
          setHasNewContacts(false);
        }
      }
    } catch (error) {
      console.error("Error al actualizar contactos:", error);
    }
  };

  //Función para mostrar el modal de confirmación de Usuarios
  const confirmDeleteUser = (userId, userName) => {
    setUserToDelete({ id: userId, name: userName });
    setDeleteModalOpen(true);
  };

  //Función para mostrar el modal de confirmación de empresas
  const confirmDeleteEmpresa = (empresaId, empresaNombre) => {
    setEmpresaToDelete({ id: empresaId, name: empresaNombre });
    setBajaEmpresaModalOpen(true);
  };

  //Función para restavblecer contraseña de un usuario
  const confirmResetPassword = (user) => {
    setUserToResetPassword(user);
    setShowPasswordResetModal(true);
  };

  //Función para desactivar un usuario
  const handleDeleteUser = async (userID) => {
    setIsOpenSpinner(true);

    try {
      const response = await fetch(
        `${API_URL}deleteColaborador.php?id=${userID}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        setMsg("Cuenta desactivada correctamente");
        setShowToast(true);
        setIsOpenSpinner(false);
        //Actualizar la lista de usuarios después de eliminar
        getUsuarios();
        setTimeout(() => {
          setShowToast(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Error al eliminar el usuario", error);
      setMsg("Error al eliminar el usuario");
      setShowToastError(true);
      setIsOpenSpinner(false);
      setTimeout(() => {
        setShowToastError(false);
      }, 5000);
    }

    //cerrar el modal después de eliminar
    setDeleteModalOpen(false);
    setUserToDelete(null);
  };

  //Función para reactivar un usuario
  const handleReactivarCuenta = (usuario) => {
    setUserToReactivate(usuario);
    setShowReactivarModal(true);
  };

  const confirmReactivarCuenta = async (uuid) => {
    setIsOpenSpinner(true);
    try {
      const response = await fetch(
        `${API_URL}updateStatusUsuario.php?uuid=${uuid}`,
        {
          method: "POST", // ✅ ya corregido
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      );

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        throw new Error("Formato de respuesta inválido");
      }

      if (!response.ok) {
        throw new Error(data.error || "No se pudo reactivar la cuenta");
      }

      setMsg("Cuenta reactivada correctamente");
      setShowToast(true);
      setShowReactivarModal(false); // ✅ se cierra al confirmar
      getUsuarios(); // ✅ refrescar lista
    } catch (error) {
      console.error("Error:", error);
      setMsg(`Error: ${error.message}`);
      setShowToastError(true);
    } finally {
      setIsOpenSpinner(false);
      // Solo ocultar los toasts después de tiempo
      setTimeout(() => {
        setShowToast(false);
        setShowToastError(false);
      }, 5000);
    }
  };

  const handleConfirmReactivarCuenta = (user) => {
    setSelectedUserToReactivate(user);
    setIsReactivationModalOpen(true);
  };

  const handleReactivarCuentaFinal = async () => {
    if (!selectedUserToReactivate) return;

    await updateStatusUsuario(selectedUserToReactivate.uuid);
    setIsReactivationModalOpen(false);
    setSelectedUserToReactivate(null);
  };

  // Función para eliminar un usuario permanentemente
  const handleDeletePermanente = async (id) => {
    setIsOpenSpinner(true);
    try {
      const response = await fetch(
        `${API_URL}deleteColaboradorPermanente.php?id=${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      // Primero obtenemos el texto de la respuesta
      const responseText = await response.text();

      // Intentamos parsear el texto como JSON
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (parseError) {
        console.error("Error al parsear la respuesta JSON:", parseError);
        console.error("Respuesta recibida:", responseText);
        throw new Error("Formato de respuesta inválido");
      }

      if (!response.ok) {
        throw new Error(
          responseData.error || "Error al eliminar permanentemente",
        );
      }

      setMsg("Usuario eliminado permanentemente");
      setShowToast(true);
      getUsuarios();
    } catch (error) {
      console.error("Error:", error);
      setMsg(`Error: ${error.message}`);
      setShowToastError(true);
    } finally {
      setIsOpenSpinner(false);
      setTimeout(() => {
        setShowToast(false);
        setShowToastError(false);
      }, 5000);
    }
  };

  const confirmDeletePermanente = (userId, userName) => {
    setUserToDelete({ id: userId, name: userName });
    setDeletePermanentModalOpen(true);
  };

  const handleSort = (field) => {
    // Si hacemos clic en el mismo campo, cambiamos la dirección
    if (field === sortField) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      // Si cambiamos de campo, establecemos el nuevo campo y dirección ascendente por defecto
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const getEmpresa = () => {
    fetch(`${API_URL}getEmpresas.php`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        // Verificar si la respuesta es ok
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.text(); // Cambiar a text() para inspeccionar la respuesta
      })
      .then((text) => {
        // Intentar encontrar el JSON en el texto
        const startIndex = text.indexOf("[{");
        const endIndex = text.lastIndexOf("}]") + 2;

        const jsonResponse =
          startIndex !== -1 && endIndex !== -1
            ? text.substring(startIndex, endIndex)
            : text;

        try {
          const responseData = JSON.parse(jsonResponse);

          if (Array.isArray(responseData)) {
            setEmpresasData(responseData);
          } else {
            console.error("La respuesta no es un array:", responseData);
          }
        } catch (error) {
          console.error("Error al parsear JSON de empresas:", error);
          console.error("Texto que no se pudo parsear:", jsonResponse);
        }
      })
      .catch((error) => {
        console.error("Error completo al obtener empresas:", error);
      });
  };

  useEffect(() => {}, [empresasData]);
  {
    /*-------------------- Fin Componente filtro y buscador y eliminación de usuarios/empresas --------------------*/
  }
  const [showTooltip, setShowTooltip] = useState(false);
  const [usuariosData, setUsuariosData] = useState("");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [activeTab, setActiveTab] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [showToastError, setShowToastError] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState(null);
  const [IsOpenSpinner, setIsOpenSpinner] = useState(false);
  const [newsletter, setNewsletter] = useState("");
  const [evento, setEvento] = useState("");
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    url_pdf: null, // Changed to null to hold the file object
    imagen: null, // Changed to null to hold the file object
  });
  const [formEvento, setFormEvento] = useState({
    nombre: "",
    descripcion: "",
    fecha: "",
    hora: "",
    imagen: null,
    ubicacion: "",
  });

  const [formErrors, setFormErrors] = useState(false);

  const handleInputChangeBoletin = (e) => {
    // Handling input changes for text fields
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleInputChangeEvento = (e) => {
    // Handling input changes for text fields
    const { name, value } = e.target;
    setFormEvento({ ...formEvento, [name]: value });
  };

  const handleFileChangeBoletin = (e) => {
    // Handling input changes for file inputs
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] }); // Assuming only single file selection
  };
  const handleFileChangeEvento = (e) => {
    // Handling input changes for file inputs
    const { name, files } = e.target;
    setFormEvento({ ...formEvento, [name]: files[0] }); // Assuming only single file selection
  };

  const boletinGet = () => {
    // Obtener el token más reciente del localStorage
    const currentToken = localStorage.getItem("token");

    if (!currentToken) {
      console.error("No hay token disponible");
      setMsg("No se pudo autenticar. Por favor, inicie sesión nuevamente.");
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
        // Opcional: redirigir al login si no hay token
        // navigate("/login");
      }, 5000);
      return;
    }

    fetch(`${API_URL}getBoletin.php`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${currentToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            throw new Error("Token inválido o expirado");
          }
          throw new Error(`Error en la solicitud: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        try {
          // Intenta encontrar un JSON válido dentro de la respuesta
          const jsonStart = text.indexOf("[{");
          const jsonEnd = text.lastIndexOf("}]") + 2;

          if (jsonStart >= 0 && jsonEnd > jsonStart) {
            // Extraer la parte JSON
            const jsonText = text.substring(jsonStart, jsonEnd);

            const responseData = JSON.parse(jsonText);

            setNewsletter(Array.isArray(responseData) ? responseData : []);
          } else {
            // Intenta parsear toda la respuesta como un solo objeto JSON
            const responseData = JSON.parse(text);

            if (responseData.error) {
              throw new Error(responseData.error);
            }

            setNewsletter([]);
          }
        } catch (error) {
          console.error("Error al analizar JSON de boletines:", error);
          setMsg(`Error al obtener boletines: ${error.message}`);
          setShowToastError(true);
          setTimeout(() => {
            setShowToastError(false);
          }, 5000);
          setNewsletter([]);
        }
      })
      .catch((error) => {
        console.error("Error del servidor al obtener boletines:", error);
        setMsg(`Error: ${error.message}`);
        setShowToastError(true);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
        setNewsletter([]);

        // Si el error es de autenticación, podemos redirigir al login
        if (
          error.message.includes("Token inválido") ||
          error.message.includes("expirado")
        ) {
          // Opcional: limpiar el token del localStorage
          localStorage.removeItem("token");
          // Opcional: redirigir al login
          // navigate("/login");
        }
      });
  };

  const getEvento = () => {
    fetch(`${API_URL}getEventos.php`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.text())
      .then((text) => {
        const startIndex = text.indexOf("[{");
        const jsonResponse =
          startIndex !== -1 ? text.substring(startIndex) : text;

        try {
          const responseData = JSON.parse(jsonResponse);

          setEvento(responseData);
        } catch (error) {
          console.error("Error al analizar JSON:", error);
        }
      })
      .catch((error) => {
        console.error("Error del servidor:", error);
      });
  };
  const handleSubmitBoletin = async (e) => {
    e.preventDefault();
    setIsOpenSpinner(true);

    const formDataToSend = new FormData();
    formDataToSend.append("nombre", formData.nombre);
    formDataToSend.append("descripcion", formData.descripcion);
    formDataToSend.append("imagen", formData.imagen);
    formDataToSend.append("url_pdf", formData.url_pdf);

    try {
      const response = await fetch(`${API_URL}insertBoletin.php`, {
        method: "POST",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        setIsOpenSpinner(false);
        setMsg("Boletín registrado exitosamente");
        setShowToast(true);
        boletinGet();

        // Limpiar completamente el formulario
        setFormData({
          nombre: "",
          descripcion: "",
          url_pdf: null,
          imagen: null,
        });

        // Limpiar los campos de archivo (importante)
        const fileInputs = document.querySelectorAll('input[type="file"]');
        fileInputs.forEach((input) => {
          input.value = "";
        });

        setTimeout(() => {
          setShowToast(false);
        }, 5000);
      } else {
        setIsOpenSpinner(false);
        setMsg("Error al registrar el boletín");
        setShowToastError(true);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setIsOpenSpinner(false);
      setMsg("Error al registrar el boletín");
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
      }, 5000);
    }
  };

  const handleSubmitEvento = async (e) => {
    e.preventDefault();
    setIsOpenSpinner(true);

    // Validar que todos los campos obligatorios estén completos
    if (
      !formEvento.nombre ||
      !formEvento.imagen ||
      !formEvento.fecha ||
      !formEvento.hora ||
      !formEvento.ubicacion ||
      !formEvento.descripcion
    ) {
      setMsg("Todos los campos son obligatorios");
      setShowToastError(true);
      setIsOpenSpinner(false);
      setTimeout(() => {
        setShowToastError(false);
      }, 5000);
      return;
    }

    const formDataToSend2 = new FormData();
    formDataToSend2.append("nombre", formEvento.nombre);
    formDataToSend2.append("descripcion", formEvento.descripcion);
    formDataToSend2.append("fecha", formEvento.fecha);
    formDataToSend2.append("hora", formEvento.hora);
    formDataToSend2.append("imagen", formEvento.imagen);
    formDataToSend2.append("ubicacion", formEvento.ubicacion);

    try {
      const response = await fetch(`${API_URL}insertEvento.php`, {
        method: "POST",
        body: formDataToSend2,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        setIsOpenSpinner(false);
        setMsg("Evento registrado correctamente");
        setShowToast(true);
        getEvento(); // Actualizar la lista de eventos

        // Limpiar completamente el formulario
        setFormEvento({
          nombre: "",
          descripcion: "",
          fecha: "",
          hora: "",
          imagen: null,
          ubicacion: "",
        });

        // Limpiar los campos de archivo (importante)
        const fileInputs = document.querySelectorAll('input[type="file"]');
        fileInputs.forEach((input) => {
          input.value = "";
        });

        setTimeout(() => {
          setShowToast(false);
        }, 5000);
      } else {
        setIsOpenSpinner(false);
        setMsg("Error al registrar el evento: " + (await response.text()));
        setShowToastError(true);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setIsOpenSpinner(false);
      setMsg("Error al registrar el evento. Por favor, intente de nuevo.");
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
      }, 5000);
    }
  };

  const handleOpenDeleteModal = (boletin) => {
    setBoletinToDelete(boletin);
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setBoletinToDelete(null);
  };

  const handleDeleteBoletin = (id) => {
    setIsOpenSpinner(true);

    fetch(`${API_URL}deleteBoletin.php?id=${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          setMsg("Boletín eliminado correctamente");
          setShowToast(true);

          // Actualización inmediata de la interfaz (eliminar el boletín del estado local)
          if (newsletter && Array.isArray(newsletter)) {
            const updatedNewsletters = newsletter.filter(
              (item) => item.id !== id,
            );
            setNewsletter(updatedNewsletters);
          }

          // También intentar obtener datos actualizados del servidor después de un retraso
          setTimeout(() => {
            boletinGet();
            setIsOpenSpinner(false);
          }, 1000);

          setTimeout(() => {
            setShowToast(false);
          }, 5000);
        } else {
          throw new Error(`Error del servidor: ${response.status}`);
        }
      })
      .catch((error) => {
        console.error("Error al eliminar el boletín:", error);
        setMsg("Error al eliminar el boletín");
        setShowToastError(true);
        setIsOpenSpinner(false);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
      });
  };

  // Función para ver detalles del boletín
  const handleViewBoletin = (boletin) => {
    setSelectedBoletin(boletin);
    setIsViewModalOpen(true);
  };

  const handleOpenPDF = () => {
    if (selectedBoletin && selectedBoletin.url_pdf) {
      const pdfUrl = `${API_URL}${selectedBoletin.url_pdf}`;
      window.open(pdfUrl, "_blank");
    } else {
      setMsg("No se encuentra el PDF de este boletín");
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
      }, 5000);
    }
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
    setSelectedBoletin(null);
  };

  const getUsuarios = () => {
    fetch(`${API_URL}getUsuarios.php?filtro=${selectedFilter}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.text())
      .then((text) => {
        const startIndex = text.indexOf("[{");
        const jsonResponse =
          startIndex !== -1 ? text.substring(startIndex) : text;

        try {
          const responseData = JSON.parse(jsonResponse);
          setUsuariosData(responseData);
        } catch (error) {
          console.error("Error al analizar JSON 2:", error);
        }
      })
      .catch((error) => {
        console.error("Error del servidor:", error);
      });
  };

  const updateStatusUsuario = (uuid) => {
    fetch(`${API_URL}updateStatusUsuario.php?uuid=${uuid}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setMsg("Cuenta reactivada correctamente");
        setShowToast(true);
        getUsuarios();

        // ✅ Aquí cerramos el modal y limpiamos el usuario seleccionado
        setIsReactivationModalOpen(false);
        setSelectedUserToReactivate(null);

        // ✅ Cerramos el toast después de 5 segundos
        setTimeout(() => {
          setShowToast(false);
        }, 5000);
      })
      .catch((error) => {
        console.error("Error del servidor:", error);
        setMsg(`Error: ${error.message}`);
        setShowToastError(true);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
      });
  };

  const handleOpenDeleteEventoModal = (evento) => {
    setEventoToDelete(evento);
    setIsDeleteEventoModalOpen(true);
  };

  const handleCloseDeleteEventoModal = () => {
    setEventoToDelete(null);
    setIsDeleteEventoModalOpen(false);
  };

  const handleDeleteEvento = async (id) => {
    setIsOpenSpinner(true);

    try {
      const response = await fetch(`${API_URL}deleteEvento.php?id=${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        setMsg("Evento eliminado correctamente");
        setShowToast(true);
        getEvento(); // Refrescamos eventos
      } else {
        throw new Error("Error al eliminar el evento");
      }
    } catch (error) {
      console.error("Error al eliminar el evento", error);
      setMsg("Error al eliminar el evento");
      setShowToastError(true);
    } finally {
      setIsOpenSpinner(false);
      setIsDeleteEventoModalOpen(false);
      setEventoToDelete(null);
    }
  };

  const getContactanos = () => {
    fetch(`${API_URL}getContactanos.php`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.text())
      .then((text) => {
        const startIndex = text.indexOf("[{");
        const jsonResponse =
          startIndex !== -1 ? text.substring(startIndex) : text;

        try {
          const responseData = JSON.parse(jsonResponse);

          setContactosData(responseData);
        } catch (error) {
          console.error("Error al analizar JSON:", error);
        }
      })
      .catch((error) => {
        console.error("Error del servidor:", error);
      });
  };
  const valueFormatter = function (number) {
    return "$ " + new Intl.NumberFormat("mx").format(number).toString();
  };

  const handleRecoveryPassword = async (email) => {
    setIsOpenSpinner(true);
    setRecoveryStatus({ email, status: "" }); // resetea mientras carga

    try {
      const response = await fetch(`${API_URL}updateContrasenia.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `email=${encodeURIComponent(email)}`,
      });

      const text = await response.text();
      const jsonResponse = text.substring(text.indexOf("[{"));
      const responseData = JSON.parse(jsonResponse);

      if (response.ok) {
        setMsg("Se ha enviado a su email su nueva contraseña");
        setShowToast(true);
        setRecoveryStatus({ email, status: "success" });

        setTimeout(() => {
          setShowToast(false);
          setRecoveryStatus({ email: "", status: "" }); // volver a candado azul
        }, 5000);

        setIsOpenSpinner(false);
      } else {
        setMsg("Ha ocurrido un error, email no encontrado en base de datos");
        setError(response.statusText || "Error desconocido");
        setRecoveryStatus({ email, status: "error" });

        setTimeout(() => {
          setRecoveryStatus({ email: "", status: "" }); // volver a candado azul
        }, 5000);

        setIsOpenSpinner(false);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setMsg("Error de red. Intenta más tarde");
      setShowToastError(true);
      setRecoveryStatus({ email, status: "error" });
    } finally {
      setIsOpenSpinner(false);
      setTimeout(() => {
        setShowToast(false);
        setShowToastError(false);
        setRecoveryStatus({ email: "", status: "" });
      }, 5000);
    }
  };

  useEffect(() => {
    getUsuarios();
  }, [selectedFilter]);

  {
    /*-------------------- Inicio useEffect para eliminar empresas --------------------*/
  }
  useEffect(() => {
    if (token == null || token == undefined || token == "") {
      navigate("/login");
    } else {
      getContactanos();
      getUsuarios();
      getEmpresa();
      boletinGet();
      getEvento();
    }
  }, []);

  //Función para eliminar empresas
  const handleDeleteEmpresa = (idEmpresa) => {
    setIsOpenSpinner(true);

    fetch(`${API_URL}deleteEmpresa.php?id=${idEmpresa}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          setMsg("Empresa eliminada correctamente");
          setShowToast(true);
          getEmpresa(); // Actualizar la lista de empresas
          setTimeout(() => {
            setShowToast(false);
          }, 5000);
        } else {
          throw new Error("Error al eliminar la empresa");
        }
      })
      .catch((error) => {
        console.error("Error al eliminar la empresa", error);
        setMsg("Error al eliminar la empresa");
        setShowToastError(true);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
      })
      .finally(() => {
        setIsOpenSpinner(false);
        // Cerrar el modal después de eliminar
        setBajaEmpresaModalOpen(false);
        setEmpresaToDelete(null);
      });
  };
  {
    /*-------------------- Fin useEffect para eliminar empresas --------------------*/
  }

  {
    /*-------------------- Inicio Funciones para editar empresas --------------------*/
  }
  // Función para abrir el modal de edición con los datos de la empresa
  const handleOpenEditEmpresa = (empresa) => {
    setEmpresaToEdit(empresa);
    setEditEmpresaForm({
      id_empresa: empresa.id_empresa || "",
      nombre: empresa.nombre || "",
      giro: empresa.giro || "",
      direccion: empresa.direccion || "",
      rfc: empresa.rfc || "",
      tamanio: empresa.tamanio || "",
      estado: empresa.estado || "",
      municipio: empresa.municipio || "",
      especialidad: empresa.especialidad || "",
      sede: empresa.sede || "",
      fundacion: empresa.fundacion || "",
      sitioWeb: empresa.sitioWeb || "",
      telefono: empresa.telefono || "",
      email: empresa.email || "",
      colorHex: empresa.colorHex || "#000000",
      mision: empresa.mision || "",
      vision: empresa.vision || "",
      instagram: empresa.instagram || "",
      facebook: empresa.facebook || "",
      linkedin: empresa.linkedin || "",
      googleUrl: empresa.googleUrl || "",
      whatsapp: empresa.whatsapp || "",
      logo: null,
      portada: null,
    });
    setEditEmpresaModalOpen(true);
  };

  // Función para cerrar el modal de edición
  const handleCloseEditEmpresa = () => {
    setEditEmpresaModalOpen(false);
    setEmpresaToEdit(null);
    setEditEmpresaForm({
      id_empresa: "",
      nombre: "",
      giro: "",
      direccion: "",
      rfc: "",
      tamanio: "",
      estado: "",
      municipio: "",
      especialidad: "",
      sede: "",
      fundacion: "",
      sitioWeb: "",
      telefono: "",
      email: "",
      colorHex: "#000000",
      mision: "",
      vision: "",
      instagram: "",
      facebook: "",
      linkedin: "",
      googleUrl: "",
      whatsapp: "",
      logo: null,
      portada: null,
    });
  };

  // Función para manejar cambios en el formulario de edición
  const handleEditEmpresaChange = (e) => {
    const { name, value } = e.target;
    setEditEmpresaForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Función para manejar cambios en los archivos
  const handleEditEmpresaFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setEditEmpresaForm((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    }
  };

  // Función para enviar la actualización de la empresa
  const handleSubmitEditEmpresa = async (e) => {
    e.preventDefault();
    setIsOpenSpinner(true);

    try {
      const formDataToSend = new FormData();

      // Agregar todos los campos al FormData
      Object.keys(editEmpresaForm).forEach((key) => {
        if (editEmpresaForm[key] !== null && editEmpresaForm[key] !== "") {
          formDataToSend.append(key, editEmpresaForm[key]);
        }
      });

      const response = await fetch(`${API_URL}updateEmpresaAdmin.php`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const text = await response.text();
      let responseData;

      try {
        const startIndex = text.indexOf("[{");
        const endIndex = text.lastIndexOf("}]") + 2;
        const jsonResponse =
          startIndex !== -1 && endIndex !== -1
            ? text.substring(startIndex, endIndex)
            : text;
        responseData = JSON.parse(jsonResponse);
      } catch (parseError) {
        responseData = JSON.parse(text);
      }

      if (response.ok) {
        setMsg("Empresa actualizada correctamente");
        setShowToast(true);
        getEmpresa(); // Actualizar la lista de empresas
        handleCloseEditEmpresa();
        setTimeout(() => {
          setShowToast(false);
        }, 3000);
      } else {
        throw new Error(
          responseData?.error || "Error al actualizar la empresa",
        );
      }
    } catch (error) {
      console.error("Error al actualizar la empresa:", error);
      setMsg(error.message || "Error al actualizar la empresa");
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
      }, 3000);
    } finally {
      setIsOpenSpinner(false);
    }
  };
  {
    /*-------------------- Fin Funciones para editar empresas --------------------*/
  }

  {
    /*-------------------- Inicio useEffect para buscar empresas --------------------*/
  }
  useEffect(() => {
    if (!empresasData || empresasData.length === 0) {
      setFilteredEmpresas([]);
      return;
    }

    let filtered = [...empresasData];

    // Aplicando búsqueda
    if (searchTermEmpresa.trim() !== "") {
      const searchLower = searchTermEmpresa.toLowerCase();
      filtered = filtered.filter(
        (empresa) =>
          empresa.nombre?.toLowerCase().includes(searchLower) ||
          empresa.giro?.toLowerCase().includes(searchLower) ||
          empresa.estado?.toLowerCase().includes(searchLower) ||
          empresa.direccion?.toLowerCase().includes(searchLower),
      );
    }

    // Aplicando filtro de giro
    if (filterGiro) {
      filtered = filtered.filter(
        (empresa) => empresa.giro?.toLowerCase() === filterGiro.toLowerCase(),
      );
    }

    // Aplicando filtro de estado
    if (filterEstado) {
      filtered = filtered.filter(
        (empresa) =>
          empresa.estado?.toLowerCase() === filterEstado.toLowerCase(),
      );
    }

    // Aplicando ordenamiento
    filtered.sort((a, b) => {
      // Manejo de diferentes campos para ordenar
      switch (sortField) {
        case "id_empresa":
          return sortDirection === "asc"
            ? (parseInt(a[sortField]) || 0) - (parseInt(b[sortField]) || 0)
            : (parseInt(b[sortField]) || 0) - (parseInt(a[sortField]) || 0);

        case "nombre":
        case "giro":
        case "especialidad":
        case "estado":
        case "direccion":
          return sortDirection === "asc"
            ? (a[sortField] || "").localeCompare(b[sortField] || "")
            : (b[sortField] || "").localeCompare(a[sortField] || "");

        default:
          return 0;
      }
    });

    setFilteredEmpresas(filtered);
  }, [
    empresasData,
    searchTermEmpresa,
    filterGiro,
    filterEstado,
    sortField,
    sortDirection,
  ]);

  // Función para manejar el ordenamiento de empresas
  const handleSortEmpresas = (field) => {
    if (field === sortField) {
      // Si es el mismo campo, cambia la dirección
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      // Si es un campo nuevo, establece el campo y la dirección ascendente
      setSortField(field);
      setSortDirection("asc");
    }
  };
  {
    /*-------------------- Fin useEffect para buscar empresas --------------------*/
  }

  {
    /*-------------------- Inicio useEffect para manejar la búsquedas y el filtrado --------------------*/
  }
  useEffect(() => {
    if (!usuariosData || usuariosData.length === 0) {
      setFilteredUsuarios([]);
      return;
    }

    let filtered = [...usuariosData];

    if (filterType === "activos") {
      filtered = filtered.filter((user) => user.estatus === "1");
    } else if (filterType === "inactivos") {
      filtered = filtered.filter((user) => user.estatus === "0");
    }

    // Aplicando filtros por estatus de empresa
    if (filterType === "ya_registrada") {
      filtered = filtered.filter(
        (user) => user.validaEmpresa === "Ya registrada",
      );
    } else if (filterType === "no_registrada") {
      filtered = filtered.filter(
        (user) => user.validaEmpresa === "No registrada",
      );
    } else if (filterType === "sin_empresa") {
      filtered = filtered.filter(
        (user) => user.validaEmpresa === "Sin empresa",
      );
    }
    // Aplicando búsqueda
    if (searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (user) =>
          user.nombreCompleto?.toLowerCase().includes(searchLower) ||
          user.email?.toLowerCase().includes(searchLower) ||
          user.empresa?.toLowerCase().includes(searchLower),
      );
    }

    // Aplicando ordenamiento
    filtered.sort((a, b) => {
      // Manejo especial para ordenar por ID (que puede ser un string en algunos casos)
      if (sortField === "id_usuario") {
        const aValue = parseInt(a[sortField]) || 0;
        const bValue = parseInt(b[sortField]) || 0;
        return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
      }
      // Manejo especial para ordenar por nombre alfabéticamente
      else if (sortField === "nombreCompleto") {
        return sortDirection === "asc"
          ? a[sortField]?.localeCompare(b[sortField] || "")
          : b[sortField]?.localeCompare(a[sortField] || "");
      }
      // Manejo especial para ordenar por email alfabéticamente
      else if (sortField === "email") {
        return sortDirection === "asc"
          ? a[sortField]
              ?.toLowerCase()
              .localeCompare(b[sortField]?.toLowerCase() || "")
          : b[sortField]
              ?.toLowerCase()
              .localeCompare(a[sortField]?.toLowerCase() || "");
      }

      // Manejo especial para ordenar por estatus de empresa
      else if (sortField === "validaEmpresa") {
        return sortDirection === "asc"
          ? a[sortField]?.localeCompare(b[sortField] || "")
          : b[sortField]?.localeCompare(a[sortField] || "");
      }

      // Manejo especial para ordenar por empresa alfabéticamente
      else if (sortField === "empresa") {
        return sortDirection === "asc"
          ? a[sortField]?.localeCompare(b[sortField] || "")
          : b[sortField]?.localeCompare(a[sortField] || "");
      }

      // Manejo especial para ordenar por fecha
      else if (sortField === "fechaRegistro") {
        const dateA = new Date(a[sortField] || "");
        const dateB = new Date(b[sortField] || "");
        return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Manejo especial para ordenar por estatus de usuario (validado/pendiente)
      else if (sortField === "estatus") {
        return sortDirection === "asc"
          ? a[sortField]?.localeCompare(b[sortField] || "")
          : b[sortField]?.localeCompare(a[sortField] || "");
      }

      // Ordenamiento predeterminado para otros campos
      else {
        const aValue = a[sortField] || "";
        const bValue = b[sortField] || "";
        return sortDirection === "asc"
          ? aValue.toString().localeCompare(bValue.toString())
          : bValue.toString().localeCompare(aValue.toString());
      }
    });

    setFilteredUsuarios(filtered);
  }, [usuariosData, searchTerm, filterType, sortField, sortDirection]);
  {
    /*-------------------- Fin useEffect para manejar la búsquedas y el filtrado  --------------------*/
  }

  useEffect(() => {
    const lastViewed = localStorage.getItem("lastContactView");

    if (contactosData.length > 0) {
      const latestContact = contactosData[0].fechaRegistro;

      if (!lastViewed || new Date(latestContact) > new Date(lastViewed)) {
        setHasNewContacts(true);
      } else {
        setHasNewContacts(false);
      }
    }
  }, [contactosData]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetch(`${API_URL}getContactanos.php`)
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) {
            const contactosConResaltado = data.map((item) => {
              const esNuevo =
                item.visto === "0" ||
                item.visto === 0 ||
                (lastSeenRef.current &&
                  new Date(item.fechaRegistro) > new Date(lastSeenRef.current));

              return {
                ...item,
                resaltado: esNuevo,
              };
            });

            setContactosData(contactosConResaltado);

            const nuevos = contactosConResaltado.filter(
              (item) => item.resaltado,
            );

            if (nuevos.length > 0) {
              // actualizar el último mensaje visto
              const fechaMasReciente = nuevos[0].fechaRegistro;
              localStorage.setItem("lastContactView", fechaMasReciente);
              lastSeenRef.current = fechaMasReciente; // actualizar también el ref

              setHasNewContacts(true);
            } else {
              setHasNewContacts(false);
            }
          }
        })
        .catch((error) =>
          console.error("Error al actualizar contactos:", error),
        );
    }, 30000); // cada 30 segundos

    return () => clearInterval(interval); // limpiar al desmontar
  }, []);

  return (
    <div className="w-full absolute left-0 right-0 bottom-0 top-0">
      <Spinner isOpen={IsOpenSpinner}></Spinner>{" "}
      {showToast && <Toast isOpen={true} title="Éxito" text={msg} />}{" "}
      {showToastError && <ToastError isOpen={true} title="Error" text={msg} />}{" "}
      <Headers></Headers>
      <div className="pb-10 pt-24 px-5 bg-gray-100">
        <div className="xl:flex block">
          <div className=" w-full bg-white border m-0 rounded-lg  p-2 md:p-4">
            <Tabs
              onSelect={async (index) => {
                setActiveTab(index);

                if (index === 2) {
                  // Contactanos
                  await fetchContactosYResaltar(); // <- Este hace todo en cuanto entras

                  try {
                    await fetch(`${API_URL}updateContactVisto.php`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                    });
                  } catch (error) {
                    console.error(
                      "Error al marcar mensajes como vistos:",
                      error,
                    );
                  }
                }
              }}
              selectedIndex={activeTab}
            >
              <TabList
                style={{
                  display: "flex",
                  justifyContent: "center",
                  listStyle: "none",
                }}
              >
                <Tab
                  style={{
                    width: "50%",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <label class="justify-center cursor-pointer items-center flex">
                    <box-icon
                      type="solid"
                      name="user-check"
                      size="sm"
                    ></box-icon>
                    &nbsp;Nuevos usuarios
                  </label>
                </Tab>
                <Tab
                  style={{
                    width: "50%",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <label class="justify-center cursor-pointer items-center flex">
                    <box-icon type="solid" name="building" size="sm"></box-icon>
                    &nbsp;Empresas
                  </label>
                </Tab>
                <Tab
                  style={{
                    width: "50%",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <label className="justify-center cursor-pointer items-center flex relative">
                    <div className="relative flex items-center">
                      <box-icon
                        type="solid"
                        name="envelope"
                        size="sm"
                      ></box-icon>
                      {hasNewContacts && nuevosContactos.length > 0 && (
                        <span className="absolute -top-1 -left-2 bg-red-500 text-white text-xs rounded-full px-1.5">
                          {nuevosContactos.length}
                        </span>
                      )}
                    </div>
                    &nbsp;Registro de contactos
                  </label>
                </Tab>
                <Tab
                  style={{
                    width: "50%",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <label class="justify-center cursor-pointer items-center flex">
                    <box-icon
                      type="solid"
                      name="purchase-tag-alt"
                      size="sm"
                    ></box-icon>
                    &nbsp;Boletines
                  </label>
                </Tab>
                <Tab
                  style={{
                    width: "50%",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <label class="justify-center cursor-pointer items-center flex">
                    <box-icon type="solid" name="map-pin" size="sm"></box-icon>
                    &nbsp;Eventos
                  </label>
                </Tab>
              </TabList>

              {/*-------------------- Inicio Sección Usuarios  --------------------*/}
              <TabPanel>
                <TabUsuarios
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  filterType={filterType}
                  setFilterType={setFilterType}
                  setSelectedFilter={setSelectedFilter}
                  handleSort={handleSort}
                  sortField={sortField}
                  sortDirection={sortDirection}
                  showTooltip={showTooltip}
                  setShowTooltip={setShowTooltip}
                  filteredUsuarios={filteredUsuarios}
                  recoveryStatus={recoveryStatus}
                  confirmResetPassword={confirmResetPassword}
                  confirmDeleteUser={confirmDeleteUser}
                  handleConfirmReactivarCuenta={handleConfirmReactivarCuenta}
                  confirmDeletePermanente={confirmDeletePermanente}
                />
              </TabPanel>
              {/*-------------------- Fin Sección Usuarios  --------------------*/}

              {/*-------------------- Inicio Sección Empresas  --------------------*/}
              <TabPanel>
                <TabEmpresas
                  searchTermEmpresa={searchTermEmpresa}
                  setSearchTermEmpresa={setSearchTermEmpresa}
                  filterGiro={filterGiro}
                  setFilterGiro={setFilterGiro}
                  filterEstado={filterEstado}
                  setFilterEstado={setFilterEstado}
                  handleSortEmpresas={handleSortEmpresas}
                  handleSort={handleSort}
                  sortField={sortField}
                  sortDirection={sortDirection}
                  filteredEmpresas={filteredEmpresas}
                  handleOpenEditEmpresa={handleOpenEditEmpresa}
                  confirmDeleteEmpresa={confirmDeleteEmpresa}
                />
              </TabPanel>
              {/*-------------------- Fin Sección Empresas  --------------------*/}

              {/*-------------------- Inicio Sección Registro de Contacto --------------------*/}
              <TabPanel>
                <TabContactos
                  searchTermContacto={searchTermContacto}
                  setSearchTermContacto={setSearchTermContacto}
                  handleDownloadContactosCSV={handleDownloadContactosCSV}
                  filteredContactosData={filteredContactosData}
                  contactosData={contactosData}
                  handleSortContactos={handleSortContactos}
                  contactosSortField={contactosSortField}
                  contactosSortDirection={contactosSortDirection}
                  setSelectedContacto={setSelectedContacto}
                  setIsViewContactModalOpen={setIsViewContactModalOpen}
                  handleDownloadContactoIndividual={
                    handleDownloadContactoIndividual
                  }
                  isViewContactModalOpen={isViewContactModalOpen}
                  selectedContacto={selectedContacto}
                  handleCloseViewContactModal={handleCloseViewContactModal}
                />
              </TabPanel>
              {/*-------------------- Fin Sección Registro de Contacto --------------------*/}

              {/*-------------------- Inicio Sección Boletín  --------------------*/}
              <TabPanel>
                <TabBoletines
                  handleSubmitBoletin={handleSubmitBoletin}
                  formData={formData}
                  handleInputChangeBoletin={handleInputChangeBoletin}
                  handleFileChangeBoletin={handleFileChangeBoletin}
                  newsletter={newsletter}
                  handleOpenDeleteModal={handleOpenDeleteModal}
                  handleViewBoletin={handleViewBoletin}
                  isViewModalOpen={isViewModalOpen}
                  selectedBoletin={selectedBoletin}
                  handleOpenPDF={handleOpenPDF}
                  handleCloseViewModal={handleCloseViewModal}
                  API_URL={API_URL}
                />
              </TabPanel>
              {/*-------------------- Fin Sección Boletín  --------------------*/}

              {/*-------------------- Inicio Sección Eventos  --------------------*/}
              <TabPanel>
                <TabEventos
                  handleSubmitEvento={handleSubmitEvento}
                  formEvento={formEvento}
                  handleInputChangeEvento={handleInputChangeEvento}
                  handleFileChangeEvento={handleFileChangeEvento}
                  evento={evento}
                  handleOpenDeleteEventoModal={handleOpenDeleteEventoModal}
                />
              </TabPanel>
              {/*-------------------- Fin Sección Eventos  --------------------*/}
            </Tabs>
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 left-0 right-0">
        {/*-------------------- Inicio Modal de Confirmación Para Restablecer Contraseña de Usuarios  --------------------*/}
        {showPasswordResetModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 overflow-hidden">
              <div className="bg-blue-600 p-4 text-white flex items-center justify-center">
                <i className="bx bx-lock text-2xl mr-2"></i>
                <h3 className="text-lg font-semibold">
                  Restablecer Contraseña
                </h3>
              </div>
              <div className="p-6 text-center">
                <p className="mb-4 text-gray-700">
                  ¿Estás seguro de que deseas restablecer la contraseña del
                  usuario{" "}
                  <strong className="text-base">
                    {userToResetPassword?.nombreCompleto}
                  </strong>
                  ?
                </p>
                <p className="mb-5 text-gray-500 text-sm">
                  Se enviará una nueva contraseña temporal al correo electrónico
                  del usuario.
                </p>
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={() => setShowPasswordResetModal(false)}
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-md"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={() => {
                      handleRecoveryPassword(userToResetPassword.email);
                      setShowPasswordResetModal(false);
                    }}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*-------------------- Inicio Modal de Confirmación Para Restablecer Contraseña de Usuarios  --------------------*/}

        {/*-------------------- Inicio Modal de Confirmación Para Desactivar Usuarios  --------------------*/}
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center transition-opacity ${
            deleteModalOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden transform transition-transform duration-300">
            <div className="bg-[#F47F36] p-4">
              <div className="flex items-center justify-center">
                <i className="bx bx-user-minus text-white text-2xl mr-1"></i>
                <p className="text-xl font-semibold text-white">
                  Desactivar Cuenta
                </p>
              </div>
            </div>
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="">
                  <p className="text-gray-700 font-medium mb-4">
                    ¿Estás seguro de que deseas desactivar la cuenta de usuario
                    de{" "}
                    <strong className="text-base text-black font-semibold">
                      {" "}
                      {userToDelete?.name || ""}
                    </strong>
                    ?
                  </p>
                  <p className="text-gray-500">
                    El usuario tendrá que ponerse en contacto con el
                    administrador para reactivar la cuenta.
                  </p>
                </div>
              </div>
              <div className="flex justify-center space-x-8">
                <button
                  onClick={() => setDeleteModalOpen(false)}
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline"
                >
                  Cancelar
                </button>
                <button
                  onClick={() => handleDeleteUser(userToDelete?.id)}
                  className="bg-[#E87A35] hover:bg-[#F47F36] text-white font-semibold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline"
                >
                  Desactivar Cuenta
                </button>
              </div>
            </div>
          </div>
        </div>
        {/*-------------------- Fin Modal de Confirmación Para Desactivar Usuarios  --------------------*/}

        {/*-------------------- Inicio Modal de Confirmación Para Reactivar Usuarios  --------------------*/}
        {isReactivationModalOpen && selectedUserToReactivate && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center transition-opacity">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden transform transition-transform duration-300">
              <div className="bg-green-600 p-4">
                <div className="flex items-center justify-center">
                  <i className="bx bx-reset text-white text-2xl mr-1"></i>
                  <p className="text-xl font-semibold text-white">
                    Reactivar Cuenta
                  </p>
                </div>
              </div>
              <div className="p-6">
                <p className="text-gray-700 font-medium mb-4 text-center">
                  ¿Estás seguro de que deseas reactivar la cuenta de{" "}
                  <strong>{selectedUserToReactivate.nombreCompleto}</strong>?
                </p>
                <div className="flex justify-center space-x-8">
                  <button
                    onClick={() => setIsReactivationModalOpen(false)}
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 py-1 px-4 rounded"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={() =>
                      handleReactivarCuentaFinal(selectedUserToReactivate?.uuid)
                    }
                    className="bg-green-600 hover:bg-green-700 text-white py-1 px-4 rounded"
                  >
                    Reactivar Cuenta
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*-------------------- Fin Modal de Confirmación Para Reactivar Usuarios  --------------------*/}

        {/*-------------------- Modal Confirmación Eliminar Permanentemente Usuario --------------------*/}
        {deletePermanentModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden">
              <div className="bg-red-700 p-4">
                <div className="flex items-center justify-center">
                  <i className="bx bxs-trash text-white text-2xl mr-1"></i>
                  <p className="text-xl font-semibold text-white">
                    Eliminar Permanentemente
                  </p>
                </div>
              </div>
              <div className="p-6">
                <p className="text-gray-700 font-medium mb-4 text-center">
                  ¿Estás seguro de que deseas eliminar permanentemente al
                  usuario{" "}
                  <strong className="text-base text-black font-semibold">
                    {userToDelete?.name}
                  </strong>
                  ?
                </p>
                <p className="text-gray-500 mb-6 text-bold">
                  Esta acción eliminará todos los datos del usuario y no se
                  puede deshacer.
                </p>
                <div className="flex justify-center space-x-8">
                  <button
                    onClick={() => setDeletePermanentModalOpen(false)}
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-lg"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={() => {
                      handleDeletePermanente(userToDelete?.id);
                      setDeletePermanentModalOpen(false);
                    }}
                    className="bg-red-700 hover:bg-red-800 text-white font-semibold py-2 px-4 rounded-lg"
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*-------------------- Fin Modal Confirmación Eliminar Permanentemente Usuario --------------------*/}

        {/*-------------------- Inicio Modal de Confirmación Para Eliminar Empresas  --------------------*/}
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center transition-opacity ${
            bajaEmpresaModalOpen
              ? "opacity-100"
              : "opacity-0 pointer-events-none"
          }`}
        >
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden transform transition-transform duration-300">
            <div className="bg-red-700 p-4">
              <div className="flex items-center justify-center">
                <i className="bx bx-trash text-white text-2xl mr-1"></i>
                <p className="text-xl font-semibold text-white">
                  Eliminar Empresa
                </p>
              </div>
            </div>
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="">
                  <p className="text-gray-700 font-medium mb-1">
                    ¿Estás seguro de que deseas eliminar la empresa{" "}
                    <strong className="text-base text-black font-semibold">
                      {" "}
                      {empresaToDelete?.name || ""}{" "}
                    </strong>{" "}
                    ?
                  </p>
                  <p className="text-gray-500">
                    Esta acción no se puede deshacer.
                  </p>
                </div>
              </div>
              <div className="flex justify-center space-x-8">
                <button
                  onClick={() => setBajaEmpresaModalOpen(false)}
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline"
                >
                  Cancelar
                </button>
                <button
                  onClick={() => handleDeleteEmpresa(empresaToDelete?.id)}
                  className="bg-red-700 hover:bg-red-800 text-white font-semibold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline"
                >
                  Eliminar Empresa
                </button>
              </div>
            </div>
          </div>
        </div>
        {/*-------------------- Fin Modal de Confirmación Para Eliminar Empresa  --------------------*/}

        {/*-------------------- Inicio Modal de Edición de Empresa --------------------*/}
        {editEmpresaModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center mt-12 justify-center bg-black bg-opacity-50 overflow-y-auto py-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 overflow-hidden">
              <div className="bg-blue-600 p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <i className="bx bx-edit text-white text-2xl mr-2"></i>
                    <p className="text-xl font-semibold text-white">
                      Editar Empresa: {empresaToEdit?.nombre}
                    </p>
                  </div>
                  <button
                    onClick={handleCloseEditEmpresa}
                    className="text-white hover:text-gray-200"
                  >
                    <i className="bx bx-x text-3xl"></i>
                  </button>
                </div>
              </div>
              <form
                onSubmit={handleSubmitEditEmpresa}
                className="p-6 max-h-[70vh] overflow-y-auto"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {/* Nombre */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nombre de la empresa *
                    </label>
                    <input
                      type="text"
                      name="nombre"
                      value={editEmpresaForm.nombre}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      required
                    />
                  </div>

                  {/* Giro */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Giro
                    </label>
                    <select
                      name="giro"
                      value={editEmpresaForm.giro}
                      onChange={handleEditEmpresaChange}
                      className="appearance-none w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 cursor-pointer"
                    >
                      <option value="">Selecciona un giro</option>
                      <option value="tecnologia">Tecnología</option>
                      <option value="industrial">Industrial</option>
                      <option value="alimentos">Alimentos</option>
                      <option value="servicios">Servicios</option>
                      <option value="construccion">Construcción</option>
                      <option value="educacion">Educación</option>
                      <option value="salud">Salud</option>
                      <option value="entretenimiento">Entretenimiento</option>
                      <option value="comercio">Comercio</option>
                      <option value="otro">Otro</option>
                    </select>
                  </div>

                  {/* Especialidad */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Especialidad
                    </label>
                    <input
                      type="text"
                      name="especialidad"
                      value={editEmpresaForm.especialidad}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* RFC */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      RFC
                    </label>
                    <input
                      type="text"
                      name="rfc"
                      value={editEmpresaForm.rfc}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Tamaño */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Tamaño
                    </label>
                    <select
                      name="tamanio"
                      value={editEmpresaForm.tamanio}
                      onChange={handleEditEmpresaChange}
                      className="appearance-none w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 cursor-pointer"
                    >
                      <option value="">Tamaño de la empresa</option>
                      <option value="De 1 a 19 empleados">
                        De 1 a 19 empleados
                      </option>
                      <option value="De 20 a 99 empleados">
                        De 20 a 99 empleados
                      </option>
                      <option value="De 100 a 499 empleados">
                        De 100 a 499 empleados
                      </option>
                    </select>
                  </div>

                  {/* Estado */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Estado
                    </label>
                    <select
                      name="estado"
                      value={editEmpresaForm.estado}
                      onChange={handleEditEmpresaChange}
                      className="appearance-none w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 cursor-pointer"
                    >
                      <option value="">Selecciona un estado</option>
                      <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                      <option value="BAJA CALIFORNIA">BAJA CALIFORNIA</option>
                      <option value="BAJA CALIFORNIA SUR">
                        BAJA CALIFORNIA SUR
                      </option>
                      <option value="CAMPECHE">CAMPECHE</option>
                      <option value="COAHUILA DE ZARAGOZA">
                        COAHUILA DE ZARAGOZA
                      </option>
                      <option value="COLIMA">COLIMA</option>
                      <option value="CHIAPAS">CHIAPAS</option>
                      <option value="CHIHUAHUA">CHIHUAHUA</option>
                      <option value="CIUDAD DE MÉXICO">CIUDAD DE MÉXICO</option>
                      <option value="DURANGO">DURANGO</option>
                      <option value="GUANAJUATO">GUANAJUATO</option>
                      <option value="GUERRERO">GUERRERO</option>
                      <option value="HIDALGO">HIDALGO</option>
                      <option value="JALISCO">JALISCO</option>
                      <option value="ESTADO DE MÉXICO">ESTADO DE MÉXICO</option>
                      <option value="MICHOACÁN">MICHOACÁN</option>
                      <option value="MORELOS">MORELOS</option>
                      <option value="NAYARIT">NAYARIT</option>
                      <option value="NUEVO LEÓN">NUEVO LEÓN</option>
                      <option value="OAXACA">OAXACA</option>
                      <option value="PUEBLA">PUEBLA</option>
                      <option value="QUERÉTARO">QUERÉTARO</option>
                      <option value="QUINTANA ROO">QUINTANA ROO</option>
                      <option value="SAN LUIS POTOSÍ">SAN LUIS POTOSÍ</option>
                      <option value="SINALOA">SINALOA</option>
                      <option value="SONORA">SONORA</option>
                      <option value="TABASCO">TABASCO</option>
                      <option value="TAMAULIPAS">TAMAULIPAS</option>
                      <option value="TLAXCALA">TLAXCALA</option>
                      <option value="VERACRUZ">VERACRUZ</option>
                      <option value="YUCATÁN">YUCATÁN</option>
                      <option value="ZACATECAS">ZACATECAS</option>
                    </select>
                  </div>

                  {/* Municipio */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Municipio
                    </label>
                    <input
                      type="text"
                      name="municipio"
                      value={editEmpresaForm.municipio}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Dirección */}
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Dirección
                    </label>
                    <input
                      type="text"
                      name="direccion"
                      value={editEmpresaForm.direccion}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Sede */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Sede
                    </label>
                    <input
                      type="text"
                      name="sede"
                      value={editEmpresaForm.sede}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Fundación */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Año de fundación
                    </label>
                    <input
                      type="text"
                      name="fundacion"
                      value={editEmpresaForm.fundacion}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Sitio Web */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Sitio Web
                    </label>
                    <input
                      type="url"
                      name="sitioWeb"
                      value={editEmpresaForm.sitioWeb}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Teléfono */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Teléfono
                    </label>
                    <input
                      type="text"
                      name="telefono"
                      value={editEmpresaForm.telefono}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* WhatsApp */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      WhatsApp
                    </label>
                    <input
                      type="text"
                      name="whatsapp"
                      value={editEmpresaForm.whatsapp}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={editEmpresaForm.email}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Color Hex */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Color corporativo
                    </label>
                    <div className="flex items-center gap-2">
                      <input
                        type="color"
                        name="colorHex"
                        value={editEmpresaForm.colorHex}
                        onChange={handleEditEmpresaChange}
                        className="h-10 w-14 border border-gray-300 rounded cursor-pointer"
                      />
                      <input
                        type="text"
                        value={editEmpresaForm.colorHex}
                        onChange={handleEditEmpresaChange}
                        name="colorHex"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>

                  {/* Google URL */}
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      URL de Google Maps
                    </label>
                    <input
                      type="url"
                      name="googleUrl"
                      value={editEmpresaForm.googleUrl}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Redes Sociales */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      <i className="bx bxl-instagram text-pink-600 mr-1"></i>
                      Instagram
                    </label>
                    <input
                      type="url"
                      name="instagram"
                      value={editEmpresaForm.instagram}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="https://instagram.com/..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      <i className="bx bxl-facebook text-blue-600 mr-1"></i>
                      Facebook
                    </label>
                    <input
                      type="url"
                      name="facebook"
                      value={editEmpresaForm.facebook}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="https://facebook.com/..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      <i className="bx bxl-linkedin text-blue-700 mr-1"></i>
                      LinkedIn
                    </label>
                    <input
                      type="url"
                      name="linkedin"
                      value={editEmpresaForm.linkedin}
                      onChange={handleEditEmpresaChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="https://linkedin.com/..."
                    />
                  </div>

                  {/* Misión */}
                  <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Misión
                    </label>
                    <textarea
                      name="mision"
                      value={editEmpresaForm.mision}
                      onChange={handleEditEmpresaChange}
                      rows="3"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                    ></textarea>
                  </div>

                  {/* Visión */}
                  <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Visión
                    </label>
                    <textarea
                      name="vision"
                      value={editEmpresaForm.vision}
                      onChange={handleEditEmpresaChange}
                      rows="3"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                    ></textarea>
                  </div>

                  {/* Logo */}
                  <div className="md:col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Logo (dejar vacío para mantener actual)
                    </label>
                    <input
                      type="file"
                      name="logo"
                      onChange={handleEditEmpresaFileChange}
                      accept="image/*"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                    {empresaToEdit?.logo && (
                      <p className="text-xs text-gray-500 mt-1">
                        Actual: {empresaToEdit.logo.split("/").pop()}
                      </p>
                    )}
                  </div>

                  {/* Portada */}
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Portada (dejar vacío para mantener actual)
                    </label>
                    <input
                      type="file"
                      name="portada"
                      onChange={handleEditEmpresaFileChange}
                      accept="image/*"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                    {empresaToEdit?.portada && (
                      <p className="text-xs text-gray-500 mt-1">
                        Actual: {empresaToEdit.portada.split("/").pop()}
                      </p>
                    )}
                  </div>
                </div>

                {/* Botones */}
                <div className="flex justify-end space-x-4 mt-6 pt-4 border-t">
                  <button
                    type="button"
                    onClick={handleCloseEditEmpresa}
                    className="px-6 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg transition-colors"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center"
                  >
                    <i className="bx bx-save mr-2"></i>
                    Guardar cambios
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/*-------------------- Fin Modal de Edición de Empresa --------------------*/}

        {/*-------------------- Inicio Modal de confirmación de eliminar Boletín --------------------*/}
        {isDeleteModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden w-full max-w-md mx-4">
              <div className="bg-red-700 px-4 py-3 text-white flex items-center justify-center">
                <i className="bx bx-trash text-2xl mr-2"></i>
                <h3 className="text-lg font-medium">Eliminar Boletín</h3>
              </div>
              <div className="p-6 text-center">
                <p className="mb-5 text-gray-700">
                  ¿Estás seguro de que deseas eliminar el boletín{" "}
                  <span className="font-bold">{boletinToDelete?.nombre}</span>?
                </p>
                <p className="mb-5 text-gray-500 text-sm">
                  Esta acción no se puede deshacer.
                </p>
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={handleCloseDeleteModal}
                    className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-md"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={() => {
                      handleDeleteBoletin(boletinToDelete.id);
                      handleCloseDeleteModal();
                    }}
                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md"
                  >
                    Eliminar Boletín
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*-------------------- Fin Modal de confirmación de eliminar Boletín --------------------*/}

        {/*-------------------- Inicio Modal de Confirmación Para Eliminar Eventos  --------------------*/}
        {isDeleteEventoModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden w-full max-w-md mx-4">
              <div className="bg-red-700 px-4 py-3 text-white flex items-center justify-center">
                <i className="bx bx-trash text-2xl mr-2"></i>
                <h3 className="text-lg font-medium">Eliminar Evento</h3>
              </div>
              <div className="p-6 text-center">
                <p className="mb-5 text-gray-700">
                  ¿Estás seguro de que deseas eliminar el evento{" "}
                  <strong className="text-base text-black font-semibold">
                    {eventoToDelete?.nombre}
                  </strong>
                  ?
                </p>
                <p className="mb-5 text-gray-500 text-sm">
                  Esta acción no se puede deshacer.
                </p>
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={handleCloseDeleteEventoModal}
                    className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-md"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={() => handleDeleteEvento(eventoToDelete?.id)}
                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md"
                  >
                    Eliminar Evento
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*-------------------- Fin Modal de Confirmación Para Eliminar Eventos  --------------------*/}
        <FooterTransparent></FooterTransparent>
      </div>
    </div>
  );
}
export default AnalyticsPage;
